import React, { use, useEffect, useRef, useState } from "react";
import Home from "./pages/Home";
import LoggedOut from "./pages/LoggedOut";
import bg from "./assets/bg.png";
import { Mode } from "./types/Mode";
import {
  buildWebSocketClient,
  sendDisconnectEvent,
} from "./helper/WebsocketClient";
import { AuthData } from "./types/AuthData";
import WebClient from "./pages/WebClient";

function App() {
  const [loggedOut, setLoggedOut] = useState<boolean>(false);
  const [mode, setMode] = useState<Mode>(Mode.MAIN);
  const [token, setToken] = useState<string | null>(null);
  const [authData, setAuthData] = useState<AuthData | null>(null);
  const [socket, setSocket] = useState<WebSocket | undefined>(undefined);
  const [volumeUpdater, setVolumeUpdater] = useState<number>(Date.now());

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const tokenParam = params.get("token");
    const modeParam = params.get("mode");

    if (!tokenParam) {
      setLoggedOut(true);
      return;
    }

    const resolvedMode = modeParam === "dev" ? Mode.DEV : Mode.MAIN;

    setToken(tokenParam);
    setMode(resolvedMode);
  }, []);

  const startSession = () => {
    if (token != null) {
      const ws = buildWebSocketClient(
        "wss://playfinity.net:" + mode,
        mode,
        token,
        () => {
          setLoggedOut(true);
          setAuthData(null);
        },
        setAuthData,
        () => {
          setVolumeUpdater(Date.now());
        },
      );

      setSocket(ws);
    }
  };

  return (
    <div className="w-full h-full">
      {authData ? (
        <WebClient data={authData} volumeUpdater={volumeUpdater} />
      ) : loggedOut ? (
        <LoggedOut bg={bg} />
      ) : (
        <Home startSession={startSession} bg={bg} />
      )}
    </div>
  );
}

export default App;
